export default __webpack_public_path__ + "static/overview2-891e4d9c68d9f63f068119752ad75ae9.jpg";